// src/components/Footer.jsx
import React from "react";
import "./Footer.css";
import footerlogo from '../../assets/images/new-white-logo.png';
import { Link } from "react-router-dom";

const Footer = () => {
    // Scroll to top handler
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };

    return (
        <footer className="footer">
            <div className="footer-container">

                {/* About Company */}
                <div className="footer-section">
                    <div className="footer-logo-wrapper">
                        <img src={footerlogo} alt="Sabiote Logo" />
                    </div>
                    <p>
                        We design and manufacture high-quality, indigenous medical devices for surgery and infection control — proudly made in India.
                    </p>
                </div>

                {/* Quick Links */}
                <div className="footer-section">
                    <h3>Quick Links</h3>
                    <ul className="quick-links-box">
                        <li>
                            <Link to="/" onClick={scrollToTop}>Home</Link>
                        </li>
                        <li>
                            <Link to="/innovation" onClick={scrollToTop}>Our Development Journey</Link>
                        </li>
                        <li>
                            <Link to="/resources" onClick={scrollToTop}>Downloads</Link>
                        </li>
                        <li>
                            <a
                                href="https://wa.me/919910652055"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>

                {/* Contacts */}
                <div className="footer-section">
                    <h3>Contacts</h3>
                    <p><strong>Address:</strong> H-212, First Floor, Noida Sec-63, Noida-201301</p>
                    <p><strong>Phone:</strong> <a href="tel:+919910652055">+91 99106 52055</a></p>
                    <p><strong>Whatsapp:</strong> <a href="https://wa.me/919910652055" target="_blank" rel="noopener noreferrer">Chat on Whatsapp</a></p>
                    <p><strong>Email:</strong> <a href="mailto:sales@sabiote.in">sales@sabiote.in</a></p>
                </div>

            </div>

            <div className="footer-bottom">
                <p>© 2025 <strong>Sabiote Healthcare Pvt. Ltd.</strong> All rights reserved</p>
            </div>
        </footer>
    );
};

export default Footer;
